import React, { useEffect, useState } from "react";
import { FaBell } from "react-icons/fa";
import API from "../api";
import "./Navbar.css";

export default function Navbar({ sidebarOpen, toggleSidebar }) {
  const [count, setCount] = useState(0);
  const [notifications, setNotifications] = useState([]);
  const [open, setOpen] = useState(false);

  const loadData = async () => {
    const countRes = await API.get("/leaves/pending-count");
    const listRes = await API.get("/leaves/notifications");

    setCount(countRes.data.count);
    setNotifications(listRes.data);
    console.log("listRes.data", listRes.data);
  };

  useEffect(() => {
    loadData();
    const interval = setInterval(loadData, 30000);
    return () => clearInterval(interval);
  }, []);

  const markRead = async (id) => {
    await API.put(`/leaves/mark-read/${id}`);
    loadData();
  };

  const markAllRead = async () => {
    await API.put("/leaves/mark-all-read");
    loadData();
  };

  return (
    <div className="navbar">
      <div className={`navbar-inner ${!sidebarOpen ? "full" : ""}`}>
        <div className="nav-left">
          <button onClick={toggleSidebar} className="hamburger">☰</button>
          <h3>Attendance Dashboard</h3>
        </div>

        <div className="nav-right">
          <div className="notification">
            <FaBell className="bell-icon" onClick={() => setOpen(!open)} />
            {count > 0 && <span className="notification-count">{count}</span>}

            {open && (
              <div className="notification-box">
                <div className="notification-header">
                  <span>Notifications</span>
                  <button onClick={markAllRead}>Mark All as Read</button>
                </div>

                {notifications.length === 0 ? (
                  <p className="empty">No notifications</p>
                ) : (
                  notifications.map(n => (
                    <div key={n.id} className="notification-item">
                      <div>
                        <strong>{n.user_name}</strong>
                        <p>{n.subject}</p>
                      </div>
                      <button onClick={() => markRead(n.id)}>
                        Mark as Read
                      </button>
                    </div>
                  ))
                )}
              </div>
            )}
          </div>

          <div className="user-info">Admin</div>
        </div>
      </div>
    </div>
  );
}
